import React from 'react';
import * as S from './style';

export interface systemCheckProps {
  maintenanceData:  {
    maintenance?: Boolean;
    message?: string;
  };
}

const SystemCheckPage = ({maintenanceData}: systemCheckProps): React.ReactElement => {
  const message = maintenanceData.message || '';
  return (
    <S.Wrapper>
      <S.LogoImageWrapper>
        <S.LogoImage />
      </S.LogoImageWrapper>
      <S.WarningImage />
      <S.UnderLineBox />
      <S.Heading>시스템 점검중 입니다</S.Heading>
      <S.UnderLineBox />
      <S.Message>저희 짐싸에 방문해 주셔서 감사합니다</S.Message>
      <S.Message dangerouslySetInnerHTML={{ __html: message }} />
    </S.Wrapper>
  );
};

export default SystemCheckPage;
